import { render, staticRenderFns } from "./FacultativeSummaryView.vue?vue&type=template&id=ab2a7236&scoped=true&"
import script from "./FacultativeSummaryView.vue?vue&type=script&lang=js&"
export * from "./FacultativeSummaryView.vue?vue&type=script&lang=js&"
import style0 from "./FacultativeSummaryView.vue?vue&type=style&index=0&id=ab2a7236&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2a7236",
  null
  
)

export default component.exports